import script from "./LandingPageUmrahRamadanSaudi.vue?vue&type=script&setup=true&lang=ts"
export * from "./LandingPageUmrahRamadanSaudi.vue?vue&type=script&setup=true&lang=ts"

import "./LandingPageUmrahRamadanSaudi.vue?vue&type=style&index=0&id=0c4a5fe9&scoped=true&lang=css"
import "./LandingPageUmrahRamadanSaudi.vue?vue&type=style&index=1&id=0c4a5fe9&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c4a5fe9"]])

export default __exports__